var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-9"},[_c('p',{staticClass:"form-control-static unselect",attrs:{"id":'static-' + _vm.id}},[_vm._t("default"),_vm._v(" "),_c('a',{on:{"click":_vm.openItem}},[(_vm.openLink != undefined && _vm.show)?_c('i',{staticClass:"glyphicon glyphicon-share"}):_vm._e()])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d44fdb2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/input/StaticInput.vue
// module id = null
// module chunks = 